import React from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Grid, Typography } from '@mui/material'

import { useGlobalStyles } from '~shared/styles/globalStyles'
import GridContainer from '~shared/components/MuiGrid/GridContainer'
import Row from '~shared/components/MuiGrid/Row'
import Col from '~shared/components/MuiGrid/Col'

const AppError: React.FC = () => {
  const gs = useGlobalStyles()
  const { t } = useTranslation()

  return <Container className={gs.marginTopSmall} maxWidth={false}>
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <GridContainer gridSpacing={6} defaultColWidth={12}>
          <Row spacingTop={6}>
            <Col>
              <Typography className={gs.alignTextCenter}>
                {t('error:appInitFailed')}
              </Typography>
            </Col>
          </Row>
        </GridContainer>
      </Grid>
    </Grid>
  </Container>
}

export default AppError
